// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3WqxZ","colCheckbox":"styles_colCheckbox__3cnwu"};